export type StrategyAgentV2Options = {
  selectedValue: string;
};

/* eslint-disable i18next/no-literal-string -- vendor model and provider names */
const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  openai: 'OpenAI',
  google: 'Gemini',
  anthropic: 'Claude',
};
/* eslint-enable i18next/no-literal-string */

/**
 * Returns a human-friendly display name for a provider key, used for button
 * labels like "Retry with Gemini". Falls back to the raw provider key if not
 * recognized.
 */
export function getProviderDisplayName(provider: string): string {
  return PROVIDER_DISPLAY_NAMES[provider] ?? provider;
}
